/* Wishlist Hero: dates and prices in German format.

   The app's wishlist list prints the "added on" date with English month names
   ("24 Sep 2026") and the price through Intl.NumberFormat("en-us") ("€5.31").
   James, 24 Sep 2026: "Price and date in German format: 5,31 € (comma instead
   of dot) and 24.09.2026 (day.month.year)". The app reads these window hooks
   each time the list renders (found in its storefront bundle, extension
   wishlist-hero-95, 24 Sep 2026):
   - WishlistHero_CustomDateFormatFunction(date) -> the date text;
   - WH_CurrencyForceCustomLocale -> the Intl locale for the price.
   Prices are German on every page ("5,31 €", "1.234,50 €"): the shop sells in
   euro from Germany. Dates follow the page language: 24.09.2026 on /de,
   24/09/2026 on /en (day first in both). If the app stops reading the hooks,
   it falls back to its defaults; nothing breaks.
   Tested by tools/ci/test_wishlist_hero.mjs. */
(function () {
  var lang = (document.documentElement.getAttribute('lang') || 'de').toLowerCase();

  window.WishlistHero_CustomDateFormatFunction = function (date) {
    try {
      return new Intl.DateTimeFormat(lang === 'en' ? 'en-GB' : 'de-DE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).format(date);
    } catch (e) {
      return date.toLocaleDateString();
    }
  };

  window.WH_CurrencyForceCustomLocale = 'de-DE';
})();
